exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".backz[data-v-442a3848]{z-index:0!important}.simpleText[data-v-442a3848]{padding:4px;margin:0}.input-group-addon[data-v-442a3848]{padding:5px 10px;border:0}.input-group-addon button i[data-v-442a3848]{color:#c4c4c4}.title span i[data-v-442a3848]{margin-left:5px;color:#c4c4c4}", ""]);

// exports
